/* eslint-disable no-undef */
import axios from "axios";
import {} from "../../users/actions";

const updateLinkDetails = (messageId, advertisment_id, campaign_id, token) => async (dispatch) => {
  try {
    await axios.patch(
      `/api/v1/messages?${advertisment_id ? "advertisment_id" : "campaign_id"}=${
        advertisment_id || campaign_id
      }&updateLinkDetails=true`,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    );
  } catch (error) {
    // dispatch(updateConversationsFail(errorMsg || "Something went wrong, please try again!"));
  }
};

export default updateLinkDetails;
